module.exports = __webpack_public_path__ + "static/media/rocket_img.0145f128.jpg";